import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import moment from 'moment-timezone';
import config from '../../../../../config';
import Money from '../../../../common/money';
import Date from '../../../../common/date';
import List from './List';
import { makeSingleReportFromHistory } from '../selectors';

const History = ({ summary, history, showHistory, setShowHistory, expanded, setExpanded }) => {
  return (
    <div className="u-mt+">
      <button
        className="c-btn u-mb+"
        onClick={() => setShowHistory(!showHistory)}
      >
        History
      </button>
      <div display-if={showHistory}>
        <ReactTable
          data={summary}
          showPagination={false}
          minRows={0}
          className="c-table c-reports"
          expanded={expanded}
          columns={[
            {
              Header: 'Date Of Payout',
              accessor: 'transferDate',
              id: 'transferDate',
              className: 'u-text-center c-table-card__row--clickable',
              Cell: props => <Date date={props.value} />,
            },
            {
              Header: 'Payout Period',
              id: 'dateRange',
              className: 'u-text-center c-table-card__row--clickable',
              Cell: props => <span><Date date={props.original.fromDate} /> - <Date date={props.original.toDate} /></span>,
            },
            {
              Header: 'Deposited',
              accessor: 'barberDeposited',
              Cell: props => <Money cents={props.value} />,
              className: 'u-text-center',
            },
            {
              Header: 'Tips Deposited',
              accessor: 'tipsDeposited',
              Cell: props => <Money cents={props.value} />,
              className: 'u-text-center c-table-card__row--clickable',
            },
          ]}
          SubComponent={(row) => {
            const items = makeSingleReportFromHistory(history[moment(row.original.fromDate).format(config.dateFormatISO)]);
            return <div className="u-m-"><List {...items} history={true} /></div>;
          }}
          getTrProps={(state, rowInfo) => {
            return {
              onClick: () => {
                setExpanded({
                  ...expanded,
                  [rowInfo.viewIndex]: !expanded[rowInfo.viewIndex],
                });
              },
            };
          }}
        />
      </div>
    </div>
  );
};

History.propTypes = {
  summary: PropTypes.array,
  history: PropTypes.object,
  showHistory: PropTypes.bool,
  setShowHistory: PropTypes.func,
};
History.defaultProps = {};

export default History;
